import * as Yup from 'yup'
import { buildEnabledDays, hasAnyWorkingHours, normalizeWorkingHours } from '@/utils/schedule'
import { CourierSchedule } from '@/common/types'
import { DayEnum } from '@/common/enums'

export const initialValues = {
    workingHours: normalizeWorkingHours(),
    enabledDays: buildEnabledDays(),
    availableWeekdays: null,
    availableSaturday: null,
    deliveryRadius: '',
}

export const getInitialValues = () => {
    return Object.assign(
        {},
        initialValues,
    )
}

export const useScheme = () => {
    return Yup.object().shape({
        workingHours: Yup.array()
            .test('has-working-hours', 'Please enter available working hours', (value) => {
                return hasAnyWorkingHours((value || []) as CourierSchedule[])
            })
            .test('required-times', 'Start and end time are required for selected days.', function (value) {
                const enabledDays = (this.parent.enabledDays || {}) as Record<DayEnum, boolean>
                const normalized = normalizeWorkingHours((value || []) as CourierSchedule[])
                return Object.values(DayEnum).every((day) => {
                    if (!enabledDays[day]) return true
                    const entry = normalized.find((item) => item.day === day)
                    return Boolean(entry?.startTime) && Boolean(entry?.endTime)
                })
            }),
        availableWeekdays: Yup.boolean().required('Select available weekdays').nullable(),
        availableSaturday: Yup.boolean().required('Select available saturdays').nullable(),
        deliveryRadius: Yup.string().required('Select delivery distance'),
    })
}
